<!-- Authentication form (login/register/forgot password) -->
<template>
  <div class="form">
    <!-- Intro paragraph -->
    <div v-html="paragraph[state]" class="margin paragraph" />
    <!-- Login / Register switch -->
    <div v-if="this.state != 'reset'" class="row between-xs margin">
      <span class="col-xs-7 col-md hover-red" @click="changeState('login')">
        <b>Already registered?</b>
      </span>
      <span class="col-xs-5 col-md hover-red" @click="changeState('register')">
        <b>New to Index?</b>
      </span>
    </div>
    <!-- Input fields -->
    <div v-for="(field, index) in fields[state]" :key="index">
      <v-select
        v-if="field.type == 'select'"
        class="v-select"
        v-model="$v[field.model[0]][field.model[1]].$model"
        label="name"
        :placeholder="field.placeholder"
        :reduce="(item) => item.id"
        :options="countries"
        :clearable="false"
        :class="{
          'form-input-invalid': $v[field.model[0]][field.model[1]].$error,
        }"
      />
      <input
        v-else
        :type="field.type"
        :placeholder="field.placeholder"
        v-model="$v[field.model[0]][field.model[1]].$model"
        :class="{
          'form-input-invalid': $v[field.model[0]][field.model[1]].$error,
        }"
        @keydown.enter="
          index == fields[state].length - 1 ? submit[state]['method']() : null
        "
      />
    </div>
    <!-- Back and submit buttons -->
    <div class="row next-button between-xs">
      <div
        v-if="backMethod != null"
        class="row middle-md col-xs next-button hover-red"
        @click="backMethod"
        :class="{ inactive: !buttonActive }"
      >
        <icon icon="arrow-left" size="lg" style="margin-right: 5px" />Back
      </div>
      <div
        class="row middle-md end-xs col-xs next-button hover-red"
        @click="submit[state].method"
        :class="{ inactive: !buttonActive }"
      >
        {{ submit[state].label }}
        <icon icon="arrow-right" size="lg" style="margin-left: 5px" />
      </div>
    </div>
    <!-- Forgot password -->
    <div
      v-if="state == 'login'"
      class="row middle-md forgot-password"
      @click="changeState('forgot')"
    >
      Forgot password?
    </div>
    <!-- Errors and loading cube -->
    <div
      v-if="errors != ''"
      class="error"
      style="margin-top: 10px; white-space: pre-line"
    >
      {{ errors | errors }}
    </div>
    <div v-show="!buttonActive" style="margin-top: 20px">
      <loading-cube />
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  sameAs,
  email,
  url,
} from "vuelidate/lib/validators";

export default {
  name: "AuthForm",
  props: {
    backMethod: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      state: "login",
      buttonActive: true,
      errors: "",
      countries: [],
      user: {
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        country_id: null,
        linkedin: "",
        organisation: "",
      },
      token: null,
      paragraph: {
        login:
          "<p>Every cycle, The Index Award receives thousands of nominations from all over the world, giving us a meta-view of the current state of design and innovation. As our bank of designs has grown over the years, we’ve transformed this valuable data into the Big Picture tool, enabling users to browse our design archive of 7,000+ solutions for inspiration, trends, case studies and more.</p> In order to access Big Picture, you need to log in. Don't worry, you won't be redirected anywhere, and we won't spam you anything (unless, of course, <a target='_blank' rel='noopener' href='http://eepurl.com/dEf9ZH' aria-label='Newsletter'>you want us to</a>).",
        register:
          "<p>Every cycle, The Index Award receives thousands of nominations from all over the world, giving us a meta-view of the current state of design and innovation. As our bank of designs has grown over the years, we’ve transformed this valuable data into the Big Picture tool, enabling users to browse our design archive of 7,000+ solutions for inspiration, trends, case studies and more.</p> In order to access Big Picture, you need to log in. Don't worry, you won't be redirected anywhere, and we won't spam you anything (unless, of course, <a target='_blank' rel='noopener' href='http://eepurl.com/dEf9ZH' aria-label='Newsletter'>you want us to</a>).",
        forgot:
          "<p>Every cycle, The Index Award receives thousands of nominations from all over the world, giving us a meta-view of the current state of design and innovation. As our bank of designs has grown over the years, we’ve transformed this valuable data into the Big Picture tool, enabling users to browse our design archive of 7,000+ solutions for inspiration, trends, case studies and more.</p> In order to access Big Picture, you need to log in. Don't worry, you won't be redirected anywhere, and we won't spam you anything (unless, of course, <a target='_blank' rel='noopener' href='http://eepurl.com/dEf9ZH' aria-label='Newsletter'>you want us to</a>).",
        reset: "Reset password",
      },
      fields: {
        login: [
          {
            type: "text",
            placeholder: "Email address",
            model: ["user", "email"],
          },
          {
            type: "password",
            placeholder: "Password",
            model: ["user", "password"],
          },
        ],
        register: [
          {
            type: "text",
            placeholder: "Name *",
            model: ["user", "name"],
          },
          {
            type: "text",
            placeholder: "Email address *",
            model: ["user", "email"],
          },
          {
            type: "password",
            placeholder: "Password *",
            model: ["user", "password"],
          },
          {
            type: "password",
            placeholder: "Repeat password *",
            model: ["user", "password_confirmation"],
          },
          {
            type: "select",
            placeholder: "Country of residence",
            model: ["user", "country_id"],
          },
          {
            type: "text",
            placeholder: "Linkedin page",
            model: ["user", "linkedin"],
          },
          {
            type: "text",
            placeholder: "Organisation",
            model: ["user", "organisation"],
          },
        ],
        forgot: [
          {
            type: "text",
            placeholder: "Email address",
            model: ["user", "email"],
          },
        ],
        reset: [
          {
            type: "text",
            placeholder: "Email address",
            model: ["user", "email"],
          },
          {
            type: "password",
            placeholder: "Password",
            model: ["user", "password"],
          },
          {
            type: "password",
            placeholder: "Repeat password",
            model: ["user", "password_confirmation"],
          },
        ],
      },
      submit: {
        login: {
          label: "Login",
          method: this.login,
        },
        register: {
          label: "Sign up",
          method: this.register,
        },
        forgot: {
          label: "Send",
          method: this.forgotPassword,
        },
        reset: {
          label: "Send",
          method: this.resetPassword,
        },
      },
    };
  },
  validations: {
    user: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      password_confirmation: {
        required,
        minLength: minLength(6),
        sameAs: sameAs("password"),
      },
      country_id: {},
      linkedin: { url },
      organisation: {},
    },
  },
  methods: {
    // Changes view layout: "login", "register", "forgot", "reset"
    changeState(state) {
      this.state = state;
      this.errors = "";
      this.$v.user.$reset();
    },
    // Register
    register() {
      this.$v.user.$touch();
      if (this.$v.user.$error)
        this.errors = [
          "Make sure the email is valid and the password is at least 6 characters.",
        ];
      else if (this.buttonActive) {
        this.errors = "";
        this.buttonActive = false;
        this.$store.dispatch("register", { user: this.user }).then(
          (r) => {
            this.buttonActive = true;
            this.$router.push("/overview");
          },
          (e) => {
            this.errors = e.body.errors;
            this.buttonActive = true;
          }
        );
      }
    },
    // Login
    login() {
      this.$v.user.$touch();
      if (this.$v.user.email.$error || this.$v.user.password.$error)
        this.errors = [
          "Make sure the email is valid and the password is at least 6 characters.",
        ];
      else if (this.buttonActive) {
        this.errors = "";
        this.buttonActive = false;
        this.$store.dispatch("login", { user: this.user }).then(
          (r) => {
            this.buttonActive = true;
            this.$router.push("/overview");
          },
          (e) => {
            this.errors = e;
            this.buttonActive = true;
          }
        );
      }
    },
    // Gets a list of countries (for registration)
    getCountries() {
      this.$http
        .get(this.$store.state.apiURL + "designs/countries")
        .then((response) => {
          this.countries = response.body;
        });
    },
    // Logs out by removing token and user cookies locally
    logout() {
      this.$store.dispatch("logout");
    },
    // Sends the forgot password email
    forgotPassword() {
      if (this.user.email == "") {
        return;
      } else if (this.buttonActive) {
        this.errors = "";
        this.buttonActive = false;
        this.$store.dispatch("forgotPassword", { email: this.user.email }).then(
          (r) => {
            this.changeState("login");
            this.errors = ["Password reset sent. Please check your email."];
            this.buttonActive = true;
          },
          (e) => {
            this.errors = ["User with this email not found."];
            this.buttonActive = true;
          }
        );
      }
    },
    // Sends the reset password request
    resetPassword() {
      this.$v.user.$touch();
      if (this.$v.user.password_confirmation.$error) {
        this.errors = ["Make sure that passwords match."];
      } else if (this.$v.user.password.$error) {
        this.errors = [
          "Make sure that the password is at least 6 characters long.",
        ];
      } else if (this.buttonActive) {
        this.errors = "";
        this.buttonActive = false;
        this.$http
          .post(this.$store.state.apiURL + "reset-password", {
            token: this.token,
            email: this.user.email,
            password: this.user.password,
            password_confirmation: this.user.password_confirmation,
          })
          .then(
            (response) => {
              this.changeState("login");
              this.errors = ["Password reset successfully."];
              console.log(response);
              this.buttonActive = true;
              this.$router.push("/award/user");
            },
            (error) => {
              this.errors = ["Data not valid."];
              console.log(error);
              this.buttonActive = true;
            }
          );
      }
    },
  },
  created() {
    this.token = this.$route.params.token;
    if (this.token != null) this.state = "reset";
    this.getCountries();
  },
};
</script>

<style scoped>
.form {
  margin-bottom: 100px;
}
input[type="text"],
input[type="password"] {
  border: 1px solid var(--grey100);
  width: calc(100%);
  padding: 0.6vw;
  background-color: var(--grey100);
  font-family: "IndexText-Regular", "Helvetica";
  font-size: var(--vw22px);
  margin-bottom: 20px;
}
input::placeholder {
  opacity: 0.5;
  color: var(--black);
}
.paragraph >>> a {
  color: var(--red);
  text-decoration: none;
}
.next-button {
  cursor: pointer;
  font-weight: bold;
  font-size: var(--vw20px);
}
.inactive {
  color: var(--grey600) !important;
}
.form-input-invalid {
  border: 1px solid var(--red) !important;
}
.error {
  font-weight: bold;
  color: var(--red);
}
.forgot-password {
  margin-top: 20px;
  color: var(--grey800);
  cursor: pointer;
}
.forgot-password:hover {
  opacity: 0.8;
}
.hover-red {
  user-select: none;
}
.margin {
  margin-bottom: 20px;
}
.v-select {
  width: calc(100% + 2px);
  border: 1px solid var(--grey100);
  margin-bottom: 20px;
  font-size: var(--vw22px);
}
.v-select >>> .vs__search::placeholder,
.v-select >>> .vs__dropdown-toggle,
.v-select >>> .vs__dropdown-menu {
  border: 1px solid var(--grey100);
  border-radius: 0;
  background-color: var(--grey100);
  font-family: "IndexText-Regular", "Helvetica";
}
.v-select >>> .vs__search::placeholder {
  opacity: 0.5;
}
.v-select >>> .vs__deselect,
.v-select >>> .vs__open-indicator {
  fill: var(--grey600);
}
</style>